const SalesSummaryPage = () => {
    return (<>
       <iframe title="Sales_AND_Forecast" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=7c212b84-6617-42dd-9297-82c8df8907a5&autoAuth=true&ctid=c5689f2c-8d0b-42f6-8d80-0f9b83c06d0a" frameborder="0" allowFullScreen="true"></iframe>
    </>)
}

export default SalesSummaryPage;